import { render, staticRenderFns } from "./shopOrder.vue?vue&type=template&id=5f6a1985&scoped=true"
import script from "./shopOrder.vue?vue&type=script&lang=js"
export * from "./shopOrder.vue?vue&type=script&lang=js"
import style0 from "./shopOrder.vue?vue&type=style&index=0&id=5f6a1985&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a1985",
  null
  
)

export default component.exports